// pp-te-toca.js — pinta «Te Toca Pedir» (snippets/pp-te-toca.liquid) y el KPI
// «Próxima recompra» del Inicio, los dos con UNA sola llamada a
// GET /apps/crm/customer-te-toca.
//
// AQUÍ NO SE CALCULA NADA. El estado de cada producto (candado / frecuencia /
// fecha / inactivo), la fecha, la ventana y el pedido típico los decide la RPC
// storefront_te_toca_pedir del monorepo, con la regla que midieron dos
// backtests. Antes había cinco cálculos en el navegador y cada uno decía otra
// cosa del mismo producto; si alguien vuelve a calcular aquí, vuelven a ser dos.
//
// El mínimo para desbloquear (3 pedidos, regla del Padrino) tampoco se
// escribe aquí: cada renglón trae `pedidos` y `faltan`, y el mínimo es la
// suma.
(function () {
  'use strict';

  var ENDPOINT = '/apps/crm/customer-te-toca';
  var EN_INICIO = 3;

  // ── Puras (las prueba tests/te-toca-pedir.test.mjs) ─────────────────────

  // 'YYYY-MM-DD' → fecha LOCAL. `new Date('2026-10-14')` es UTC y en México
  // pinta el día anterior.
  function fechaLocal(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || '');
    return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
  }

  function hoyLocal(ahora) {
    var d = ahora ? new Date(ahora) : new Date();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  function diasHasta(s, ahora) {
    var f = fechaLocal(s);
    if (!f) return null;
    return Math.round((f.getTime() - hoyLocal(ahora).getTime()) / 86400000);
  }

  // «14 oct», siempre en español: el filtro `date` de Liquid sacaba «Oct».
  function fechaCorta(s) {
    var f = fechaLocal(s);
    if (!f) return '';
    try {
      return new Intl.DateTimeFormat('es-MX', { day: 'numeric', month: 'short' }).format(f).replace('.', '');
    } catch (e) {
      return f.getDate() + '/' + (f.getMonth() + 1);
    }
  }

  function poner(plantilla, valores) {
    return String(plantilla || '').replace(/\{(\w+)\}/g, function (m, k) {
      return valores[k] !== undefined && valores[k] !== null ? String(valores[k]) : m;
    });
  }

  // «5 paquetes · 500 bolsas», «5 bolsas» o «5 piezas». Nunca inventa
  // piezas por paquete: sin el dato, dice paquetes o piezas a secas.
  function cantidadTexto(it, T) {
    var q = Number(it.pedido_tipico);
    if (!isFinite(q) || q <= 0) return '';
    var pack = Number(it.piezas_por_paquete);
    var miles = function (n) { return Number(n).toLocaleString('es-MX'); };
    if (isFinite(pack) && pack > 1 && it.unidad_plural) {
      return miles(q) + ' ' + (q === 1 ? T.paquete : T.paquetes) + ' · ' + miles(q * pack) + ' ' + it.unidad_plural;
    }
    if (isFinite(pack) && pack === 1 && it.unidad_plural) {
      return miles(q) + ' ' + (q === 1 ? (it.unidad_singular || it.unidad_plural) : it.unidad_plural);
    }
    return miles(q) + ' ' + (q === 1 ? T.pieza : T.piezas);
  }

  // Reparte los renglones en las secciones de la tarjeta, en el orden en que
  // el backend los manda (lo que toca antes, primero).
  function agrupar(items) {
    var g = { toca: [], inactivos: [], candados: [] };
    (items || []).forEach(function (it) {
      if (it.estado === 'fecha' || it.estado === 'frecuencia') g.toca.push(it);
      else if (it.estado === 'inactivo') g.inactivos.push(it);
      else if (it.estado === 'candado') g.candados.push(it);
    });
    return g;
  }

  // El mínimo para desbloquear, deducido de los renglones (pedidos + faltan).
  function minimoDe(items) {
    for (var i = 0; i < (items || []).length; i++) {
      var it = items[i];
      if (it.estado === 'candado' && Number(it.faltan) > 0) return Number(it.pedidos) + Number(it.faltan);
    }
    return null;
  }

  // Badge y renglón descriptivo de un producto que ya se abrió.
  function lineasDe(it, T, ahora) {
    if (it.estado === 'fecha') {
      if (it.ya_toca) {
        return { badge: T.badgeYa, urgente: true, linea: poner(T.fechaYaLinea, { hasta: fechaCorta(it.ventana_hasta) }) };
      }
      return {
        badge: poner(T.badgeEn, { n: diasHasta(it.te_toca, ahora) }),
        urgente: false,
        linea: poner(T.fechaLinea, { fecha: fechaCorta(it.te_toca), desde: fechaCorta(it.ventana_desde), hasta: fechaCorta(it.ventana_hasta) }),
      };
    }
    if (it.estado === 'frecuencia') {
      return {
        badge: it.ya_toca ? T.badgeYa : poner(T.badgeCada, { n: it.intervalo_dias }),
        urgente: !!it.ya_toca,
        linea: poner(T.frecLinea, { n: it.intervalo_dias, d: it.dias_desde }),
      };
    }
    if (it.estado === 'inactivo') {
      return { badge: '', urgente: false, linea: poner(T.inactivoLinea, { n: it.intervalo_dias, d: it.dias_desde }) };
    }
    return { badge: '', urgente: false, linea: '' };
  }

  // El KPI «Próxima recompra» del Inicio: lo primero que toca.
  function kpiDe(items, ahora) {
    var g = agrupar(items);
    var primero = g.toca[0];
    if (!primero) return { cerrado: true, minimo: minimoDe(items) };
    var n = diasHasta(primero.te_toca, ahora);
    return { cerrado: false, ya: !!primero.ya_toca || n <= 0, fecha: primero.te_toca, dias: n, producto: primero.nombre };
  }

  // Lo que «ya te toca» para la pestaña Consumo Actual de Recompra: abierto y
  // que ya toca o toca dentro de una semana.
  var SEMANA = 7;
  function tocaYa(items, ahora) {
    return agrupar(items).toca.filter(function (it) {
      var n = diasHasta(it.te_toca, ahora);
      return !!it.ya_toca || (n !== null && n <= SEMANA);
    });
  }

  var puras = { fechaLocal: fechaLocal, diasHasta: diasHasta, fechaCorta: fechaCorta, poner: poner,
    cantidadTexto: cantidadTexto, agrupar: agrupar, minimoDe: minimoDe, lineasDe: lineasDe, kpiDe: kpiDe,
    tocaYa: tocaYa, ENDPOINT: ENDPOINT };
  if (typeof window !== 'undefined') window.PPTeToca = puras;
  if (typeof document === 'undefined') return;

  // ── DOM ─────────────────────────────────────────────────────────────────

  var raices = document.querySelectorAll('[data-pp-te-toca]');
  var kpis = document.querySelectorAll('[data-pp-te-toca-kpi]');
  if (!raices.length && !kpis.length) return;
  if (window.Shopify && window.Shopify.designMode) return;

  function textosDe(el) {
    var T = {};
    Array.prototype.forEach.call(el.attributes, function (a) {
      if (a.name.indexOf('data-t-') !== 0) return;
      var k = a.name.slice(7).replace(/-(\w)/g, function (m, c) { return c.toUpperCase(); });
      T[k] = a.value;
    });
    return T;
  }

  function el(tag, clase, texto) {
    var n = document.createElement(tag);
    if (clase) n.className = clase;
    if (texto !== undefined && texto !== null && texto !== '') n.textContent = texto;
    return n;
  }

  function imagen(it) {
    var w = el('a', 'pp-tetoca__img');
    w.href = '/products/' + it.handle;
    w.setAttribute('aria-hidden', 'true');
    w.tabIndex = -1;
    if (it.imagen) {
      var img = el('img');
      img.src = it.imagen + (it.imagen.indexOf('?') === -1 ? '?' : '&') + 'width=120';
      img.alt = '';
      img.loading = 'lazy';
      w.appendChild(img);
    }
    return w;
  }

  // El ÚNICO camino al carrito de esta tarjeta: el botón de cada renglón y
  // «Agregar seleccionados» / «Agregar todo» de la página pasan por aquí, en
  // UNA llamada (dos POST seguidos al mismo carrito pueden pisarse).
  function agregarAlCarrito(lineas) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lineas }),
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function (d) {
        document.dispatchEvent(new CustomEvent('pp:cart:updated'));
        return d;
      });
  }

  function verCarrito(T) {
    var a = el('a', 'pp-tetoca__ver-carrito', T.verCarrito + ' →');
    a.href = '/cart';
    return a;
  }

  // Lo que vale para un renglón ya agregado, venga de su botón o de la barra.
  function marcarAgregado(li, T) {
    var b = li.querySelector('.pp-tetoca__agregar');
    if (b) {
      b.disabled = true;
      b.classList.add('is-hecho');
      b.textContent = '✓ ' + T.agregado;
    }
    var c = li.querySelector('.pp-tetoca__check');
    if (c) { c.checked = false; c.disabled = true; }
    li.classList.remove('is-sel');
    li.classList.add('is-agregado');
  }

  // La línea del carrito de un renglón: su variante y su pedido típico.
  function lineaDe(it) {
    var q = Number(it.pedido_tipico);
    if (!it.variant_id || !isFinite(q) || q <= 0) return null;
    return { id: Number(it.variant_id), quantity: q };
  }

  function botonAgregar(it, T, li) {
    var cant = cantidadTexto(it, T);
    var linea = lineaDe(it);
    if (!linea) return null;
    var caja = el('div', 'pp-tetoca__accion');
    var b = el('button', 'pp-tetoca__agregar');
    // Largo y corto («Agregar», el renglón angosto del celular); el CSS escoge.
    b.appendChild(el('span', 'pp-tetoca__agregar-largo', T.agregar));
    if (T.agregarCorto) b.appendChild(el('span', 'pp-tetoca__agregar-corto', T.agregarCorto));
    b.setAttribute('aria-label', T.agregar + ': ' + it.nombre + ' (' + cant + ')');
    b.type = 'button';
    var aviso = el('span', 'pp-tetoca__aviso');
    aviso.setAttribute('role', 'status');
    b.addEventListener('click', function () {
      b.disabled = true;
      agregarAlCarrito([linea])
        .then(function () {
          marcarAgregado(li, T);
          aviso.textContent = '';
          aviso.appendChild(verCarrito(T));
          if (li._ppAlCambiar) li._ppAlCambiar();
        })
        .catch(function () {
          b.disabled = false;
          aviso.textContent = T.noSePudo;
        });
    });
    caja.appendChild(b);
    caja.appendChild(aviso);
    return caja;
  }

  // La casilla de la izquierda (sólo en la página completa). Un renglón sin
  // variante o sin pedido típico no se puede agregar: lleva el hueco, para que
  // las fotos queden en columna.
  function casilla(it, T, li) {
    var linea = lineaDe(it);
    if (!linea) return el('span', 'pp-tetoca__sel');
    var lab = el('label', 'pp-tetoca__sel');
    var c = el('input', 'pp-tetoca__check');
    c.type = 'checkbox';
    c.setAttribute('aria-label', poner(T.seleccionarAria, { nombre: it.nombre }));
    c.addEventListener('change', function () {
      li.classList.toggle('is-sel', c.checked);
      if (li._ppAlCambiar) li._ppAlCambiar();
    });
    lab.appendChild(c);
    li._ppLinea = linea;
    return lab;
  }

  // `compacto` (el Inicio, Padrino 7-oct-2026): sin el «Ya te toca» —la
  // tarjeta se llama Te Toca Pedir, se sobreentiende—, la fecha y el pedido
  // típico en UNA línea y sin «Planear» por tarjeta (va uno solo abajo).
  function filaAbierta(it, T, compacto) {
    var info = lineasDe(it, T);
    var li = el('li', 'pp-tetoca__fila' + (info.urgente ? ' is-urgente' : ''));
    if (!compacto) li.appendChild(casilla(it, T, li));
    li.appendChild(imagen(it));
    var txt = el('div', 'pp-tetoca__txt');
    var arriba = el('div', 'pp-tetoca__arriba');
    var nombre = el('a', 'pp-tetoca__nombre', it.nombre);
    nombre.href = '/products/' + it.handle;
    arriba.appendChild(nombre);
    if (info.badge && !(compacto && info.urgente)) arriba.appendChild(el('span', 'pp-tetoca__badge' + (info.urgente ? ' is-urgente' : ''), info.badge));
    txt.appendChild(arriba);
    var cant = cantidadTexto(it, T);
    // La versión CORTA de la fecha para que todo quepa en una línea.
    var corta = info.linea;
    if (it.estado === 'fecha' && it.ya_toca && T.fechaYaCorta) corta = poner(T.fechaYaCorta, { hasta: fechaCorta(it.ventana_hasta) });
    else if (it.estado === 'fecha' && T.fechaCortaLinea) corta = poner(T.fechaCortaLinea, { fecha: fechaCorta(it.te_toca) });
    else if (it.estado === 'frecuencia' && T.frecCorta) corta = poner(T.frecCorta, { n: it.intervalo_dias });
    var cortaConTipico = corta + (cant && T.tipicoCorto ? ' · ' + poner(T.tipicoCorto, { cant: cant }) : '');
    if (compacto) {
      txt.appendChild(el('p', 'pp-tetoca__linea', cortaConTipico));
    } else {
      // Página completa (Padrino, 23-oct-2026: «renglones muy grandes»): la
      // fecha y el pedido típico en UNA línea, y sin «Planear» por renglón —
      // hay uno solo arriba a la derecha de la página. Trae la línea larga
      // (con la ventana) y la corta; el CSS enseña la corta en caja angosta.
      var p = el('p', 'pp-tetoca__linea');
      var larga = el('span', 'pp-tetoca__linea-larga', info.linea);
      if (cant) {
        larga.appendChild(document.createTextNode(' · '));
        larga.appendChild(el('span', 'pp-tetoca__tipico', poner(T.tipico, { cant: cant })));
      }
      p.appendChild(larga);
      p.appendChild(el('span', 'pp-tetoca__linea-corta', cortaConTipico));
      txt.appendChild(p);
    }
    li.appendChild(txt);
    var b = botonAgregar(it, T, li);
    if (b) li.appendChild(b);
    return li;
  }

  function filaCandado(it, T, minimo) {
    var li = el('li', 'pp-tetoca__fila pp-tetoca__fila--candado');
    li.appendChild(el('span', 'pp-tetoca__sel'));
    li.appendChild(imagen(it));
    var txt = el('div', 'pp-tetoca__txt');
    var nombre = el('a', 'pp-tetoca__nombre', it.nombre);
    nombre.href = '/products/' + it.handle;
    txt.appendChild(nombre);
    txt.appendChild(el('p', 'pp-tetoca__linea', '🔒 ' + poner(T.candadoLinea, { p: it.pedidos, n: minimo, f: it.faltan })));
    var barra = el('div', 'pp-tetoca__barra');
    barra.setAttribute('role', 'img');
    barra.setAttribute('aria-label', poner(T.candadoAria, { p: it.pedidos, n: minimo }));
    var lleno = el('span');
    lleno.style.width = Math.round((100 * Number(it.pedidos)) / minimo) + '%';
    barra.appendChild(lleno);
    txt.appendChild(barra);
    li.appendChild(txt);
    return li;
  }

  function lista(filas) {
    var ul = el('ul', 'pp-tetoca__lista');
    ul.setAttribute('role', 'list');
    filas.forEach(function (f) { ul.appendChild(f); });
    return ul;
  }

  function pintar(raiz, items) {
    var T = textosDe(raiz);
    var modo = raiz.getAttribute('data-modo');
    var cuerpo = raiz.querySelector('[data-pp-te-toca-cuerpo]');
    var g = agrupar(items);
    var minimo = minimoDe(items) || 3;
    cuerpo.textContent = '';

    if (!items.length) {
      cuerpo.appendChild(el('p', 'pp-tetoca__vacio', T.vacio));
      return;
    }

    var toca = modo === 'inicio' ? g.toca.slice(0, EN_INICIO) : g.toca;
    if (toca.length) cuerpo.appendChild(lista(toca.map(function (it) { return filaAbierta(it, T, modo === 'inicio'); })));

    if (modo === 'inicio') {
      if (g.candados.length) {
        var res = el('p', 'pp-tetoca__resumen-candados', '🔒 ' + (g.candados.length === 1
          ? T.candadosResumenUno
          : poner(T.candadosResumen, { c: g.candados.length })));
        cuerpo.appendChild(res);
      }
      if (!toca.length && !g.candados.length) cuerpo.appendChild(el('p', 'pp-tetoca__vacio', T.vacio));
      // Abajo, UNA vez: «Ver Todo» a la izquierda y «Planear mi pedido» a la
      // derecha (antes había un «Planear» en cada tarjeta).
      var pie = el('div', 'pp-tetoca__pie');
      var ver = el('a', 'pp-tetoca__ver-todo', T.verTodo + ' →');
      ver.href = '/pages/cliente-te-toca';
      pie.appendChild(ver);
      if (T.planear && toca.length) {
        var plan = el('a', 'pp-tetoca__planear-pie', T.planear + ' →');
        plan.href = '/pages/cliente-proyecciones';
        pie.appendChild(plan);
      }
      cuerpo.appendChild(pie);
      return;
    }

    if (g.inactivos.length) {
      cuerpo.appendChild(el('h4', 'pp-tetoca__seccion', T.inactivosTitle));
      cuerpo.appendChild(lista(g.inactivos.map(function (it) { return filaAbierta(it, T); })));
    }
    barraSeleccion(cuerpo, T);
    if (g.candados.length) {
      cuerpo.appendChild(el('h4', 'pp-tetoca__seccion', '🔒 ' + poner(T.candadosTitle, { n: minimo })));
      cuerpo.appendChild(el('p', 'pp-tetoca__seccion-sub', poner(T.candadosSub, { n: minimo })));
      cuerpo.appendChild(lista(g.candados.map(function (it) { return filaCandado(it, T, minimo); })));
    }
  }

  // Arriba de la lista: «Seleccionar todo», «Agregar seleccionados al
  // carrito» y «Agregar todo» (Padrino, 23-oct-2026). Cada renglón entra con
  // SU pedido típico, por agregarAlCarrito, en una sola llamada.
  function barraSeleccion(cuerpo, T) {
    var filas = Array.prototype.filter.call(cuerpo.querySelectorAll('.pp-tetoca__fila'), function (li) { return !!li._ppLinea; });
    if (!filas.length) return;
    var barra = el('div', 'pp-tetoca__seleccion');
    var lab = el('label', 'pp-tetoca__todo');
    var todo = el('input', 'pp-tetoca__check');
    todo.type = 'checkbox';
    todo.setAttribute('data-pp-te-toca-todo', '');
    lab.appendChild(todo);
    lab.appendChild(el('span', null, T.selTodo));
    barra.appendChild(lab);
    var acciones = el('div', 'pp-tetoca__seleccion-acciones');
    var sel = el('button', 'pp-tetoca__btn pp-tetoca__btn--principal', T.agregarSel);
    sel.type = 'button';
    sel.setAttribute('data-pp-te-toca-agregar-sel', '');
    var all = el('button', 'pp-tetoca__btn', T.agregarTodo);
    all.type = 'button';
    all.setAttribute('data-pp-te-toca-agregar-todo', '');
    acciones.appendChild(sel);
    acciones.appendChild(all);
    barra.appendChild(acciones);
    var aviso = el('p', 'pp-tetoca__seleccion-aviso');
    aviso.setAttribute('role', 'status');
    aviso.setAttribute('data-pp-te-toca-aviso', '');
    barra.appendChild(aviso);
    cuerpo.insertBefore(barra, cuerpo.firstChild);

    var ocupado = false;
    function pendientes() { return filas.filter(function (li) { return !li.classList.contains('is-agregado'); }); }
    function marcadas() { return pendientes().filter(function (li) { var c = li.querySelector('.pp-tetoca__check'); return c && c.checked; }); }
    function alCambiar() {
      var p = pendientes().length;
      var m = marcadas().length;
      todo.checked = p > 0 && m === p;
      todo.indeterminate = m > 0 && m < p;
      todo.disabled = p === 0 || ocupado;
      sel.disabled = m === 0 || ocupado;
      sel.textContent = m === 1 ? T.agregarSelUno : m ? poner(T.agregarSelN, { n: m }) : T.agregarSel;
      all.disabled = p === 0 || ocupado;
    }
    filas.forEach(function (li) { li._ppAlCambiar = alCambiar; });
    todo.addEventListener('change', function () {
      var v = todo.checked;
      pendientes().forEach(function (li) {
        var c = li.querySelector('.pp-tetoca__check');
        if (c) c.checked = v;
        li.classList.toggle('is-sel', v);
      });
      alCambiar();
    });
    function agregar(lis) {
      if (!lis.length || ocupado) return;
      ocupado = true;
      alCambiar();
      aviso.textContent = '';
      agregarAlCarrito(lis.map(function (li) { return li._ppLinea; }))
        .then(function () {
          lis.forEach(function (li) { marcarAgregado(li, T); });
          aviso.textContent = (lis.length === 1 ? T.agregadosUno : poner(T.agregados, { n: lis.length })) + ' · ';
          aviso.appendChild(verCarrito(T));
        })
        .catch(function () { aviso.textContent = T.noSePudo; })
        .then(function () { ocupado = false; alCambiar(); });
    }
    sel.addEventListener('click', function () { agregar(marcadas()); });
    all.addEventListener('click', function () { agregar(pendientes()); });
    alCambiar();
  }

  function pintarKpi(k, items) {
    var T = textosDe(k);
    var v = k.querySelector('[data-pp-te-toca-kpi-valor]');
    var s = k.querySelector('[data-pp-te-toca-kpi-sub]');
    var d = kpiDe(items);
    if (d.cerrado) {
      v.textContent = '🔒';
      s.textContent = poner(T.kpiCerrado, { n: d.minimo || 3 });
    } else if (d.ya) {
      v.textContent = T.kpiHoy;
      s.textContent = poner(T.kpiYa, { producto: d.producto });
    } else {
      v.textContent = fechaCorta(d.fecha);
      s.textContent = poner(T.kpiEn, { n: d.dias, producto: d.producto });
    }
  }

  function fallo(raiz) {
    var T = textosDe(raiz);
    var cuerpo = raiz.querySelector('[data-pp-te-toca-cuerpo]');
    cuerpo.textContent = '';
    cuerpo.appendChild(el('p', 'pp-tetoca__error', T.error));
  }

  function mostrar(raiz) {
    var esq = raiz.querySelector('[data-pp-te-toca-esqueleto]');
    var cuerpo = raiz.querySelector('[data-pp-te-toca-cuerpo]');
    if (esq) esq.hidden = true;
    if (cuerpo) cuerpo.hidden = false;
  }

  fetch(ENDPOINT, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
    .then(function (res) {
      // items:null es «falló el servidor», NO «no tienes compras».
      var items = res.d && Array.isArray(res.d.items) ? res.d.items : null;
      Array.prototype.forEach.call(raices, function (raiz) {
        if (items) pintar(raiz, items); else fallo(raiz);
        mostrar(raiz);
      });
      Array.prototype.forEach.call(kpis, function (k) { if (items) pintarKpi(k, items); });
    })
    .catch(function () {
      Array.prototype.forEach.call(raices, function (raiz) { fallo(raiz); mostrar(raiz); });
    });
})();
